import { createContext, type ReactNode } from "react";
import { useContextAndErrorIfNull } from "~/common/hooks/use-context-and-error-if-null.js";
import { useFirebaseMessaging, type UseFirebaseMessagingOptions, type UseFirebaseMessagingReturn } from "./hooks.js";

export const FirebaseMessagingContext = createContext<UseFirebaseMessagingReturn | null>(null);

interface FirebaseMessagingProviderProps extends UseFirebaseMessagingOptions {
  children: ReactNode;
}

export const FirebaseMessagingProvider = ({ isLoggedIn, children }: FirebaseMessagingProviderProps) => {
  const value = useFirebaseMessaging({ isLoggedIn });

  return <FirebaseMessagingContext.Provider value={value}>{children}</FirebaseMessagingContext.Provider>;
};

export const useFirebaseMessagingContext = (): UseFirebaseMessagingReturn =>
  useContextAndErrorIfNull(FirebaseMessagingContext);
